export default __webpack_public_path__ + "static/media/fbicon.9e4d141b.svg";